import React from 'react';
import * as gtmEvents from '../config/gtm-events';
import useResolver from './useResolver';

const useDataLayer = () => {
  const resolver = useResolver();

  return (eventName, overrides = {}) => {
    const eventDataVariables = gtmEvents[eventName]; // eslint-disable-line

    const dataLayerObj = eventDataVariables.reduce(
      (prevDataLayerObj, dataLayerVariable) => ({
        ...prevDataLayerObj,
        [dataLayerVariable]: resolver[dataLayerVariable] && resolver[dataLayerVariable](),
        ...overrides,
      }),
      {
        event: eventName,
      }
    );

    const isGa = !!document.querySelector('script[id="ga"]');

    if (isGa) {
      if (!window?.ga) {
        return;
      }

      window.gtag('event', `${dataLayerObj.event}`, dataLayerObj);
    } else {
      if (!window.dataLayer) {
        return;
      }

      window.dataLayer.push(dataLayerObj);
    }
  };
};

export default useDataLayer;
